<template>
    <div v-show="visible">
        <el-dialog title="复制当前数据到目标学校"
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            v-loading="loading" 
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item   prop="targetSchoolId" label="目标学校">
                        <el-select v-model="form.targetSchoolId" clearable 
                        collapse-tags placeholder="请选择目标学校">
                        <el-option filterable
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 

    export default {
        data(){
            return{
                visible: false,
                form:{
                    currSchoolId:"",
                    targetSchoolId:""
                },
                depts:[],
                rules: {
                    targetSchoolId: [
                        { required: true, message: '请选择目标学校', trigger: 'blur' }
                    ]
                },
                loading:false,
                loadingText:"",
            }
        },
        created:function () {
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.currSchoolId=deptId;
                // 获取学校数据
                this.getDeptData();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        // console.log(JSON.stringify(this.depts));
                        // 去除当前学校ID
                        for(let i=0;i<this.depts.length;i++){
                            if(this.depts[i].id == this.form.currSchoolId){
                                this.depts.splice(i,1);
                            }
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let msg="目标学校的数据将会被覆盖，是否继续？";
                        this.$commonFn.showConfirm2(msg,this.saveSuccess);
                    }
               });
            },
            saveSuccess(){
                this.loading=true;
                this.loadingText="复制中...";

                let url= this.evaluateIndicatorsDefineCopyUrl;
                let data = {
                    currSchoolId:this.form.currSchoolId,
                    targetSchoolId:this.form.targetSchoolId
                };
                // console.log(JSON.stringify(data));
                // return;
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.visible=false;
                        this.$parent.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                }, (err) => {
                    console.log(err);
                    this.loading=false;
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/SetEvaluateIndicatorsDefineCopy.vue